import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

type EmptyCartProps = {
  onBrowseEvents: () => void;
};

const EmptyCart: React.FC<EmptyCartProps> = ({ onBrowseEvents }) => {
  return (
    <div className="cart-page empty-cart-page d-flex align-items-center justify-content-center" style={{ minHeight: '70vh' }}>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6}>
            <Card className="text-center border-0 shadow-lg glass position-relative overflow-hidden">
              <Card.Body className="py-5 position-relative d-flex flex-column align-items-center justify-content-center">
                <div className="mb-4">
                  <i className="fas fa-shopping-cart text-primary fa-4x mb-2" style={{ opacity: 0.7 }}></i>
                </div>
                <h2 className="fw-bold mb-3" style={{ color: "#495057", fontSize: '1.7rem' }}>Your cart is empty</h2>
                <p className="text-muted mb-4" style={{ fontSize: '1.05rem', maxWidth: 320 }}>
                  Looks like you haven&apos;t added anything yet.<br />
                  Start exploring our events and add your favorites!
                </p>
                <Button 
                  variant="primary" 
                  size="lg" 
                  className="px-4 w-100 w-sm-auto"
                  style={{ maxWidth: 240 }}
                  onClick={onBrowseEvents}
                >
                  <i className="fas fa-search me-2"></i>
                  Browse Events
                </Button>
                <div 
                  className="empty-cart-bg"
                  style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: "80px",
                    opacity: 0.3,
                    zIndex: 0,
                  }}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EmptyCart;
